import Cookies from "universal-cookie";
import { post, put } from "axios";
import { baseUrl, getApiAsyn, getPythonApiAsyn } from '../../PostAPI';
import { handleAPIError, APIError } from '../../common/errorHandler';
import { getDecoratedUrl, generateImageUrl } from '../../common/urlService';
import { API_URL } from '../../../constants/urlConstants';
import { asyncForEach } from '../../../utils/async';
import { extractData } from '../../utils';

const cookies = new Cookies();

const dataUploadApi = (url, data, isEdit = false) => {
  // const formPayload = new FormData();
  // // data part of multipart data
  // const json = JSON.stringify(data);
  // const blobData = new Blob([json], {
  //   type: 'application/json',
  // });
  // formPayload.append('data', blobData);

  // // file part of multipart data
  // files?.forEach((file) => {
  //   formPayload.append('file', file);
  // });

  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
const getFetchCustomerUrl = (payload) => {
  return getDecoratedUrl({ url: API_URL.CUSTOMERS.FETCH_CUSTOMERS, payload });
};

export const fetchCustomerMarkup = async (payload) => {
  const url = getDecoratedUrl({
    url:    API_URL.CUSTOMER_MARKUP.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCustomerByCustomerId = async (payload) => {
  const url = API_URL.CUSTOMER_MARKUP.FETCH_CUSTOMER_BY_ID.replace(
    ':id',
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, cookies.get('authorization'));

    if (result?.error) {
      throw new APIError(result);
    }

    if (result?.files?.length) {
      await asyncForEach(result.files, async (file, index, array) => {
        result.files[index].s3Url = await generateImageUrl(file.url);
      });
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const addCustomerMarkupRecord = async (payload) => {
  const url = API_URL.CUSTOMER_MARKUP.ADD;

  try {
    let result = await dataUploadApi(url, payload.data);

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const editCustomerMarkupRecord = async (payload) => {
  const url = API_URL.CUSTOMER_MARKUP.EDIT;

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchFuelCompanyProviderDD = async (payload) => {
  const url = API_URL.CUSTOMER_MARKUP.FUEL_COMPANY_PROVIDER_DD;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    let res = result?.fuel_company || [];
    res = res.map(item => ({
      label: item.fuel_company_provider,
      value: item.company_id,
      eob_parent_company_id: item.company_ref_id
    }));
    return { content: res };
   
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchFuelCustomerCompanyNameProviderDD = async (payload) => {
  const url = API_URL.CUSTOMER_MARKUP.FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD;
  try {
    let result = await getApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    let res = result || [];
    res = res.map(item => ({
      label: item.company_name,
      value: item.company_id,
      customer_id: item.customer_id
    }));
    return { content: res };
   
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

